export const SET_PACKAGES_PAGE_DATA = 'SET_PACKAGES_PAGE_DATA';
export const SET_PACKAGES_TOTAL_RECORDS = 'SET_PACKAGES_TOTAL_RECORDS';
export const SET_PACKAGES_PAGE = 'SET_PACKAGES_PAGE';
export const EDIT_PACKAGES = 'EDIT_PACKAGES';
export const ADD_PACKAGES = 'ADD_PACKAGES';
export const DELETE_PACKAGES= 'DELETE_PACKAGES';
export const PACKAGES_LOADING = 'PACKAGES_LOADING';
export const PACKAGES_FAILURE = 'PACKAGES_FAILURE';
export const GET_PACKAGES= 'GET_PACKAGES';
export const SET_PACKAGES_REDIRECT_URL = 'SET_PACKAGES_REDIRECT_URL';


export const PACKAGES_PROGRESS_TYPE={
    GET_PACKAGES_LIST:"GET_PACKAGES_LIST",
    ADD_PACKAGES_PROGRESS:"ADD_PACKAGES_PROGRESS",
    EDIT_PACKAGES_PROGRESS:"EDIT_PACKAGES_PROGRESS",
    DELETE_PACKAGES_PROGRESS:"DELETE_PACKAGES_PROGRESS"
}

